var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('react-wrapper',{style:({ height: '100%', overflowY: 'auto' }),attrs:{"component":_vm.entrust,"sdkToken":_vm.sdkToken,"workflowRunId":_vm.workflowRunId}})
}
var staticRenderFns = []

export { render, staticRenderFns }